import { render, staticRenderFns } from "./ArbitrationGuide.vue?vue&type=template&id=55594a24&scoped=true"
import script from "./ArbitrationGuide.vue?vue&type=script&lang=js"
export * from "./ArbitrationGuide.vue?vue&type=script&lang=js"
import style0 from "./ArbitrationGuide.vue?vue&type=style&index=0&id=55594a24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55594a24",
  null
  
)

export default component.exports